
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies-policy",
      function () {
        return require("private-next-pages/cookies-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookies-policy"])
      });
    }
  